
  <template>
    <svg
      xmlns="http://www.w3.org/2000/svg" :width="size" :height="size" viewBox="0 0 24 24" aria-hidden="true" :fill="color"
    >
      <path fill-rule="evenodd" clip-rule="evenodd" d="M15.0701 9.14253C14.5653 9.83882 14.0984 10.4829 13.95 11.0323C13.5817 12.3961 13.7281 13.9831 14.85 15.08H8.55C9.64961 14.0048 10.2074 12.2204 9.45 11.0323C9.2824 10.7694 9.05678 10.4607 8.80702 10.119C7.92801 8.91636 6.75 7.30468 6.75 5.84C6.75 3.16694 8.96619 1 11.7 1C14.4338 1 16.65 3.16694 16.65 5.84C16.65 6.96323 15.8185 8.11025 15.0701 9.14253ZM4 20.3601V16.8401H19.4V20.3601H4ZM19.4 22V23H4V22H19.4Z"></path>
    </svg>
  </template>
  <script>
    import { defineComponent } from "vue";

    export default defineComponent({
      name: "OiApprovalFill",
      props: {
        size: {
          type: Number,
          default: 16
        },
        color: {
          type: String,
          default: "currentColor"
        }
      }
    });
  </script>
